import { FeatureFlagKeyName } from '@mobi/settings'
import { getFeatures } from '../Store/selectors'
import { store } from '@core/Store'
import { _returnFeatureValueOrDefault } from './returnFeatureValueOrDefault'
import { FeatureValueType } from '@mobi/settings/featureFlags'

/**
 * Use this to get features from redux state to ensure default value is given if flag is not overwritten
 * @param flag the feature key in launch darkly (NOT the uppercase `keyof FeatureFlags` string)
 */
export function getFeatureValue<K extends FeatureFlagKeyName>(flag: K): FeatureValueType<K> {
  const features = getFeatures(store.getState())
  return _returnFeatureValueOrDefault(features[flag], flag) as FeatureValueType<K>
}
